import React, { useState, useEffect, useCallback } from 'react'
import { FormattedMessage } from 'react-intl'
import { Pagination } from '@mui/material'

import { Preloader } from '../../components/UI'
import { ReusableFilters } from '../calendar/components/ReusableFilters'
import { Card } from '../calendar/components/Card'
import MatchItem from './components/MatchItem'
import useGetMatches from './hooks/useGetMatches'
import useMatchFilters from './hooks/useMatchFilters'
import { PAGINATION_STYLES } from './constants'

import '../../assets/styles/Notification.css'
import styles from './styles.module.scss'

const Match = () => {
  const [isLoading, setIsLoading] = useState(false)

  const {
    matchesData,
    isLoading: hookLoading,
    pagination,
    setFilters,
    setPage,
  } = useGetMatches({})

  const { defaultValues, filterConfig, handleFiltersChange, isGamesLoading } =
    useMatchFilters()

  const handleChangeMatches = useCallback(
    (_, value) => {
      window.scrollTo({ top: 0, behavior: 'smooth' })
      setPage(value)
    },
    [setPage]
  )

  const onFiltersChange = useCallback(
    filters => {
      handleFiltersChange(filters, setFilters)
    },
    [handleFiltersChange, setFilters]
  )

  useEffect(() => {
    setIsLoading(hookLoading)
  }, [hookLoading])

  return (
    <section className={styles.matchesList} data-testid='matches-page'>
      <div className={styles.layoutContainer}>
        <ReusableFilters
          filterConfigs={filterConfig}
          defaultValues={defaultValues}
          onFiltersChange={onFiltersChange}
          isLoading={isGamesLoading}
          title='filters'
        />

        <div className={styles.content}>
          <div className={styles.matchesContainer}>
            {isLoading && !matchesData.length ? (
              <div className={styles.contentLoaderOverlay}>
                <Preloader />
                <div className={styles.loadingText}>
                  <FormattedMessage id='common.loading' />
                </div>
              </div>
            ) : null}

            {matchesData.length > 0 ? (
              <div className={styles.matchesGrid}>
                {matchesData.map(match => (
                  <Card key={match.matchId} className={styles.matchCard}>
                    <MatchItem
                      name={match?.name}
                      tournamentLogo={match.tournament.logo}
                      tournamentName={match.tournament.name}
                      nameGame={match.game.name}
                      gameLogo={match.game.logo}
                      tournamentMember1={match.tournamentMember1 || 0}
                      tournamentMember2={match.tournamentMember2 || 0}
                      tournamentMemberScore1={match.tournamentMemberScore1}
                      tournamentMemberScore2={match.tournamentMemberScore2}
                      mode={match?.mode}
                      groupsName={match.round.name}
                      startedAt={match.startedAt}
                      matchId={match.matchId}
                      status={match.status}
                      tournamentStageType={match.tournamentStageType}
                      game={match.game}
                      round={match.round}
                    />
                  </Card>
                ))}
              </div>
            ) : !isLoading ? (
              <div className={styles.emptyData}>
                <FormattedMessage id='match.ticker.noMoreMatch' />
              </div>
            ) : null}
          </div>

          {matchesData?.length > 0 && (
            <div className={styles.paginatorWrapper}>
              <Pagination
                count={pagination?.lastPage ? pagination?.lastPage : 1}
                page={pagination?.currentPage ?? 1}
                onChange={handleChangeMatches}
                variant='outlined'
                sx={PAGINATION_STYLES}
              />
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

export default Match
